import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ISSUE_MESSAGE: `${cleanedFilename(__filename)}-issue-message`,
};
